const defaultQuery = {
  page: '1', 
  count: '3',
  status: 'all',
}

export default defaultQuery

export const volumnStatusMenu = {
  '1-all': '契約', // all
  '2-2': '計算中',
  '3-3': '完成',
  '4-1': '未處理',
}

export const volumnStatus = {
  '1': '未處理',
  '2': '計算中',
  '3': '完成',
}